import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { normalizeKeyDisplay } from '../../utils/diatonicChords';
import { getSetting, settingKeys } from '../../utils/settings';

import { ReactComponent as MinusIcon } from '../../icons/minus.svg';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';

import './MidiKeyRow.scss';

/*
 * The key a clip will sound in, shown above it in both MIDI modals.
 *
 *      [–]   C   [+]
 */
const MidiKeyRow = ({ songKey, onTranspose }) => {
  const { t } = useTranslation();
  const preferSharps = getSetting(settingKeys.preferSharps) !== false;
  const displayKey = normalizeKeyDisplay(songKey, preferSharps);

  return (
    <div className="MidiKeyRow" aria-label={t('view.key')}>
      {onTranspose && (
        <button
          type="button"
          className="btn-step"
          onClick={() => onTranspose(-1)}
          aria-label={t('dialogs.midi.transposeDown')}
        >
          <MinusIcon />
        </button>
      )}
      <span className="value">{displayKey || '—'}</span>
      {onTranspose && (
        <button
          type="button"
          className="btn-step"
          onClick={() => onTranspose(1)}
          aria-label={t('dialogs.midi.transposeUp')}
        >
          <PlusIcon />
        </button>
      )}
    </div>
  );
};

MidiKeyRow.propTypes = {
  songKey: PropTypes.string,
  onTranspose: PropTypes.func,
};

export default MidiKeyRow;
